import { PapiNote } from '@wix/da-papi-types';
import { Chance } from 'chance';
import { makeEditorText } from './editorText';
import { users } from '../users';

const chance = new Chance();

export function makeNotes(count: number): PapiNote[] {
  const notes = [];
  for (let i = 0; i < count; i++) {
    notes.push({
      noteId: chance.integer(),
      folderId: chance.integer(),
      url: chance.url(),
      subject: chance.sentence(),
      timestamp: chance.timestamp().toString(),
      isUnread: i < 2,
      sender: chance.pickone(users),
      recipients: chance.pickset(users, chance.integer({ min: 1, max: 2 })),
      body: makeEditorText(),
    });
  }
  return notes;
}
